module.exports = __webpack_public_path__ + "static/media/deltalv-logo.b960a66b.svg";